import { PageRequest } from '@/core/request/PageRequest';
import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import {
  deleteNotification,
  listNotifications,
  markReadNotification,
} from './Notification.service';

export function useNotificationsByUserId(params?: PageRequest) {
  const query = useInfiniteQuery(
    ['notifications', { ...params }],
    ({ pageParam }) => {
      const req: PageRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };
      return listNotifications(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useNotificationMarkRead() {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (notificationId: number) => markReadNotification(notificationId),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Notificação marcada como lida',
        });

        queryClient.invalidateQueries(['notifications']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useNotificationDelete() {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (notificationId: number) => deleteNotification(notificationId),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso!',
          description: 'Notificação excluida com sucesso!',
        });

        queryClient.invalidateQueries(['notifications']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
